import React from "react";
import { useAuthors } from "../../../lib/firebase/author/read";
import { Link } from "react-router-dom";

export default function AuthorsListView() {
  const { data, error, isLoading } = useAuthors();

  if (isLoading) {
    return <h1 className="text-center mt-4">Loading...</h1>;
  }

  if (error) {
    return <h1 className="text-center text-danger mt-4">{error}</h1>;
  }

  if (!data || data.length === 0) {
    return <h1 className="text-center text-warning mt-4">No authors found!</h1>;
  }

  return (
    <section className="container-fluid mt-4">
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="table-primary text-center">
            <tr>
              <th scope="col">Sr.</th>
              <th scope="col">Photo</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item.id} className="text-center align-middle">
                <td>{index + 1}</td>
                <td>
                  <img
                    src={item.photoURL}
                    alt="Author Photo"
                    className="img-fluid rounded"
                    style={{ height: "40px" }}
                  />
                </td>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>
                  <Link to={`/admin/authors/form?id=${item.id}`}>
                    <button className="btn btn-sm btn-primary">Edit</button>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
